'use client';

import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

import Icon from '@/ui/components/Icon';
import { containsHTML } from '@/utils/helpers';

const ProgramWrap = styled(Box)`
  align-items: flex-start;
  align-self: stretch;
  border-radius: 0.125rem;
  border: 1px ${({ theme }) => theme.palette.gray.main} solid;
  color: ${({ theme }) => theme.palette.text.primary};
  gap: 15px;
  display: flex;
  padding: 1.25rem;

  svg {
    color: ${({ theme }) => theme.palette.primary.main};
    height: 1.375rem;
    margin-top: 2px;
    width: 1.375rem;
  }

  ${({ theme }) => theme.breakpoints.down('lg')} {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-left: 0;
    margin-right: 0;
  }
`;

const ProgramContent = styled.div`
  div,
  p {
    margin-top: 5px;
  }
`;

interface InfoBoxProps {
  title?: string;
  description?: string;
}

export default function InfoBox({ title, description }: InfoBoxProps) {
  return (
    <ProgramWrap>
      <Icon name="info-circle" style="solid" />
      <ProgramContent>
        {title && (
          <Typography variant="body2" component="h3">
            <strong>{title}</strong>
          </Typography>
        )}
        {description && containsHTML(description) ? (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          description && <Typography variant="body1">{description}</Typography>
        )}
      </ProgramContent>
    </ProgramWrap>
  );
}
